import{a as o}from"./chunk-WIMGWYZL.js";function d(...r){return o(l,r)}function l(r){let n=[...r];for(let e=0;e<r.length;e++){let t=e+Math.floor(Math.random()*(r.length-e)),a=n[t];n[t]=n[e],n[e]=a}return n}export{d as a};
